import React, { useRef } from "react";
import { useHistory } from "react-router-dom";
import {
  Container,
  SecondContainer,
  SearchButton,
  ImageOne,
  ImageTwo,
  CircleOne,
  CircleTwo,
  CircleThree,
  CircleFour,
  CircleFive,
} from "../../styles/home/introduction";

import Cropped from "../../assets/cropped.png";
import CroppedTwo from "../../assets/croppedtwo.png";
import CircleFirst from "../../assets/circle1.png";
import CircleSecond from "../../assets/circle2.png";
import CircleThird from "../../assets/circle3.svg";
import CirlceFourth from "../../assets/circle4.png";
import CirlceFifth from "../../assets/circle5.png";

const Introduction = () => {
  let inputRef = useRef();
  const history = useHistory();

  const goToSearchPage = () => {
    history.push(`/search/${inputRef.current.value || " "}`);
  };

  return (
    <>
      <Container>
        <h1>Finding care is complicated</h1>
        <h3>Aeydar makes it simple</h3>
        <input
          placeholder="Search for provider or search using your location"
          ref={inputRef}
        />
        <br />
        <SearchButton onClick={goToSearchPage}>Search</SearchButton>
        <ImageOne src={Cropped} alt="" />
        <ImageTwo src={CroppedTwo} alt="" />
        <CircleOne src={CircleFirst} alt="" />
        <CircleTwo src={CircleSecond} alt="" />
        <CircleThree src={CircleThird} alt="" />
        <CircleFour src={CirlceFourth} alt="" />
        <CircleFive src={CirlceFifth} alt="" />
      </Container>
      <SecondContainer>
        <h1>Find care when you need it the most</h1>
        <h3>For yourself and those you love</h3>
        <hr />
      </SecondContainer>
    </>
  );
};

export default Introduction;
